<template>
	<div style="">
		<div class="h90" style="height: 90px;"></div>
		<div class="fbg flex">
			<img src="../assets/images/home/logod.png" style="width: 242px;height: 87px;margin-right: 157px;" />
			<div style="display: flex;align-items: flex-start;justify-content: space-between;width: 65%;">
				<div class="tabs">
					<div class="tabTit pointer">关于S学苑</div>
					<div class="nitem" @click="toPage('/about')">关于我们</div>
					<div class="nitem" style="margin-top: 21px;" @click="openService">服务据点</div>
				</div>
				<div class="tabs">
					<div class="tabTit">快速链接</div>
					<div class="flex">
						<div class="nitem" @click="toPage('/index')">首页&nbsp;&nbsp;</div>
						<div class="nitem" @click="toMemberCenter">会员中心</div>
					</div>
					<div class="flex">
						<div class="nitem" @click="toPage('/course')">课程中心</div>
						<div class="nitem" @click="toPointsCom">积分管理</div>
					</div>
					<div class="flex">
						<div class="nitem" @click="toPage('/training')">培训中心</div>
						<div class="nitem" @click="toPage('/message')">消息中心</div>
					</div>
				</div>
				<div class="tabs">
					<div class="tabTit">帮助中心</div>
					<div class="nitem" @click="toPage('/question')">常见问题</div>
				</div>
				<div class="tabs">
					<div class="tabTit">问题反馈</div>
					<div class="nitem" @click="$refs.fedbackComRef.openDialog()">意见反馈</div>
				</div>
				<div class="tabs">
					<div class="tabTit">用户协议</div>
					<div class="nitem" @click="$router.push('/content?source=1')">用户协议</div>
					<div class="nitem" @click="$router.push('/content?source=2')">隐私政策</div>
					<div class="nitem" @click="$router.push('/content?source=3')">补充协议</div>
				</div>
			</div>
		</div>
		<div class="flex flex-b fbgd">
			<div class="tip">2025 沙迪克（厦门）有限公司 版权所有</div>
			<div class="tip">闽公网安备 35020302033377号 备案号：闽ICP备19002800号-1</div>
		</div>


		<MemberCenter ref="memberCenterRef"></MemberCenter>
		<PointsCom ref="pointsComRef"></PointsCom>
		<FedbackCom ref="fedbackComRef"></FedbackCom>
		<ServiceCom ref="serviceRef"></ServiceCom>
	</div>
</template>

<script>
	import MemberCenter from '@/components/MemberCenter.vue'
	import PointsCom from '@/components/PointsCom.vue'
	import FedbackCom from '@/components/FeedbackCom.vue'
	import ServiceCom from '@/components/ServiceCom.vue'
	export default {
		components:{
			MemberCenter,
			PointsCom,
			FedbackCom,
			ServiceCom
		},
		data() {
			return {
				showQuestion: false,
				showOpinion: false,
				navIndex: 0,
				textarea: '',
				imgList: [
					require('../../src/assets/images/home/logo.png'),
					require('../../src/assets/images/home/logo.png'),
				]
			}
		},
		methods: {
			openService(){
				this.$refs.serviceRef.openDialog()
			},
			toMemberCenter(){
				this.$refs.memberCenterRef.openDialog()
			},
			toPointsCom(){
				this.$refs.pointsComRef.openDialog()
			},
			toPage(path) {
				this.$router.push({
					path: path
				})
			},
			success() {
				this.$message({
					message: '反馈已成功提交，感觉您的提交！',
					type: 'success'
				});
			},
		}
	}
</script>

<style lang="less" scoped>
	.fbg {
		width: 100%;
		height: 256px;
		background: #000000;
		border-radius: 0px 0px 0px 0px;
		padding: 40px 0 40px 143px;

		.tabs {
			display: flex;
			align-items: flex-start;
			// margin-right: 133px;
			flex-direction: column;
			justify-content: flex-start;

			.tabTit {
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: bold;
				font-size: 18px;
				color: #FFFFFF;
			}

			.nitem {
				margin-top: 27px;
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 400;
				font-size: 18px;
				color: rgba(255, 255, 255, 0.72);
				cursor: pointer;
				width: 107px;
			}
		}
	}

	.fbgd {
		width: 100%;
		height: 36px;
		background: #333333;
		border-radius: 0px 0px 0px 0px;
		padding: 0 137px;

		.tip {
			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 400;
			font-size: 13px;
			color: rgba(255, 255, 255, 0.64);
		}
	}

	::v-deep .el-textarea__inner {
		height: 138px !important;
		background: #F7F8F9;
		border-radius: 13px 13px 13px 13px;
		border: none !important;
		padding: 16px;
		font-family: HONOR Sans CN, HONOR Sans CN;
		font-weight: 400;
		font-size: 16px;
		color: #000;

		&:focus {
			border-color: none;
		}
	}

	::v-deep .el-message--success {
		background-color: #f0f9eb !important;
		border-color: #e1f3d8 !important;
	}
	
</style>